import http from "../../http-common";

class CutoffLunchMenuService {

    getAll(data) {
        return http.post("/admin/getCutoffLunchMenu", data);
    }

    save(data) {
        return http.post("/admin/saveCutoffLunchMenu", data);
    }

    delete(id) {
        return http.delete(`/admin/cutoffLunchMenu/${id}`);
    }

}

export default new CutoffLunchMenuService();
